import {
  AddCardRequest,
  AddCardResponse,
  GetCardsResponse,
  GetMadaCardRequest,
  GetMadaCardResponse,
  GuestBookingInitializeAddCardRequest,
  InitializeAddCardResponse,
  UpdateCardRequest,
  UpdateCardResponse,
} from './models';
import { createMutation, createQuery } from '../../libs';

const cardsUrl = 'cards';
const guestCardsUrl = 'guest-users/cards';

export const useGetCards = createQuery<GetCardsResponse>({
  method: 'get',
  url: cardsUrl,
});

export const useInitializeAddCard = createQuery<InitializeAddCardResponse>({
  method: 'get',
  url: `${cardsUrl}/initialize-add-card`,
});

export const useInitHyperPayAddCard = createQuery<InitializeAddCardResponse>({
  method: 'get',
  url: `${cardsUrl}/hyper-pay/initialize-add-card`,
});

export const useInitPayFortPayAddCard = createQuery<InitializeAddCardResponse>({
  method: 'get',
  url: `${cardsUrl}/payfort/initialize-add-card`,
});

export const useGuestBookingHyperPayInitializeAddCard = createMutation<
  InitializeAddCardResponse,
  GuestBookingInitializeAddCardRequest
>({
  method: 'post',
  url: `${guestCardsUrl}/hyper-pay/initialize-add-card`,
  transformRequest: (data, headers) => {
    headers['Content-Type'] = 'application/json';
    delete headers.Authorization;
    return JSON.stringify(data);
  },
});

export const useGuestBookingPayFortInitializeAddCard = createMutation<
  InitializeAddCardResponse,
  GuestBookingInitializeAddCardRequest
>({
  method: 'post',
  url: `${guestCardsUrl}/payfort/initialize-add-card`,
  transformRequest: (data, headers) => {
    headers['Content-Type'] = 'application/json';
    delete headers.Authorization;
    return JSON.stringify(data);
  },
});

export const useAddCard = createMutation<AddCardResponse, AddCardRequest>({
  method: 'post',
  url: cardsUrl,
});

export const useUpdateCard = createMutation<UpdateCardResponse, UpdateCardRequest>({
  method: 'put',
  url: `${cardsUrl}/:id`,
});

export const useDeleteCard = createMutation<unknown, unknown>({
  method: 'delete',
  url: `${cardsUrl}/:id`,
});

export const useCheckIsMadaCardMutation = createMutation<
  GetMadaCardResponse,
  GetMadaCardRequest
>({
  method: 'post',
  url: `${cardsUrl}/check-if-mada-card`,
});
